import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const primaryMenuItems = accountId => [
  {
    icon: 'chat',
    key: 'conversations',
    label: 'CONVERSATIONS',
    toState: frontendURL(`accounts/${accountId}/dashboard`),
    toStateName: 'home',
    roles: ['administrator', 'agent'],
  },
  {
    icon: 'book-contacts',
    key: 'contacts',
    label: 'CONTACTS',
    featureFlag: FEATURE_FLAGS.CRM,
    toState: frontendURL(`accounts/${accountId}/contacts`),
    toStateName: 'contacts_dashboard',
    roles: ['administrator', 'agent'],
  },
  {
    icon: 'merge',
    key: 'workflows',
    label: 'WORKFLOWS',
    toState: frontendURL(`accounts/${accountId}/workflows`),
    toStateName: 'workflows_list',
    roles: ['administrator'],
  },
  {
    icon: 'arrow-trending-lines',
    key: 'reports',
    label: 'REPORTS',
    featureFlag: FEATURE_FLAGS.REPORTS,
    toState: frontendURL(`accounts/${accountId}/reports`),
    toStateName: 'settings_account_reports',
    roles: ['administrator'],
  },
  // Campaigns leaves the rail and uniPUSH takes its place.
  //
  // Campaigns are not run from here — uniPUSH is the product that sends them, and a second,
  // weaker campaign screen inside uniLINK only splits the question of "where do I send from"
  // across two apps. The link goes out rather than pretending the feature lives here.
  //
  // Only the NAVIGATION is removed. The campaigns store, its routes, and the conversation
  // filter's "Campaign name" attribute all stay: `ChatList.vue` and the automation-rule editor
  // both read `campaigns/getAllCampaigns` to resolve a campaign id into a name, and deleting
  // that would turn an existing saved filter into a row of blank values.
  //
  // Protocol-relative, matching the DOCS entry below, and that form is not cosmetic:
  // `router-link` resolves its `to` as a PATH, so an href beginning `https://` would be
  // resolved relative to the current account route and mangled. A leading `//` is an absolute
  // path to the router and a protocol-relative URL to the browser, which is why the one
  // existing external item in this rail is written that way.
  {
    icon: 'megaphone',
    key: 'unipush',
    label: 'UNIPUSH',
    toState: '//unipush.unirsal.com',
    toStateName: 'unipush_external',
    openInNewPage: true,
    roles: ['administrator'],
  },
  {
    icon: 'library',
    key: 'helpcenter',
    label: 'HELP_CENTER.TITLE',
    featureFlag: FEATURE_FLAGS.HELP_CENTER,
    alwaysVisibleOnChatwootInstances: true,
    toState: frontendURL(`accounts/${accountId}/portals`),
    toStateName: 'default_portal_articles',
    roles: ['administrator'],
  },
  {
    icon: 'settings',
    key: 'settings',
    label: 'SETTINGS',
    toState: frontendURL(`accounts/${accountId}/settings`),
    toStateName: 'settings_home',
    roles: ['administrator', 'agent'],
  },
];

export default primaryMenuItems;
